import { motion } from "framer-motion";
import { EASE, viewport } from "@/lib/motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={viewport}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SplitLines = ({ lines, className = "", delay = 0, stagger = 0.11, as: Tag = "h1", inView = false, ...rest }) => {
  const MTag = motion[Tag] || motion.h1;
  const parentProps = inView
    ? { initial: "hidden", whileInView: "show", viewport }
    : { initial: "hidden", animate: "show" };
  return (
    <MTag className={className} {...parentProps} {...rest}>
      {lines.map((line, i) => (
        <span className="line-mask" key={i}>
          <motion.span
            className="block"
            variants={{ hidden: { y: "112%" }, show: { y: 0, transition: { duration: 1.1, ease: EASE, delay: delay + i * stagger } } }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MTag>
  );
};

export const SectionHeading = ({ eyebrow, title, description, light = false, align = "left", testId }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={testId}>
    {eyebrow && (
      <Reveal>
        <p className={`eyebrow eyebrow-bar mb-5 ${light ? "text-[var(--terracotta)]" : "text-[var(--terracotta)]"}`}>{eyebrow}</p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.05] font-normal ${light ? "text-[var(--cream)]" : "text-[var(--ink)]"}`}>{title}</h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className={`mt-6 text-base md:text-lg leading-relaxed font-light ${light ? "text-[var(--stone)]" : "text-[var(--charcoal)]"}`}>{description}</p>
      </Reveal>
    )}
  </div>
);
